export const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime())

export const addMinutesToDate = (date, minutes) => new Date(date.getTime() + minutes * 60000)

export const addDays = (date, days) => {
  const dateCopy = new Date(date.getTime())
  dateCopy.setDate(dateCopy.getDate() + days)
  return dateCopy
}

export const isDateBefore = (dateString) => {
  const date = new Date(dateString)
  return date < new Date()
}

// Replace with toISOString when backend supports full ISO format
export const formatDateISO = (dateString, time = '') => {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${year}-${month}-${day}${time}`
}

export const localisedDate = (dateString, query) => {
  const date = new Date(dateString)
  return date.toLocaleString(navigator.language, query)
}

export function formatDate(dateString) {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

export function timeSince(dateString) {
  const date = new Date(dateString)

  if (!isValidDate(date)) {
    throw new Error('Invalid date')
  }

  const seconds = Math.floor((new Date() - date) / 1000)
  const isFuture = seconds < 0
  const absSeconds = Math.abs(seconds)
  const suffix = isFuture ? ' from now' : ' ago'
  let interval = absSeconds / 31536000

  if (interval > 1) {
    const years = Math.floor(interval)
    return years + (years === 1 ? ' year' : ' years') + suffix
  }
  interval = absSeconds / 2592000
  if (interval > 1) {
    const months = Math.floor(interval)
    return months + (months === 1 ? ' month' : ' months') + suffix
  }
  interval = absSeconds / 86400
  if (interval > 1) {
    const days = Math.floor(interval)
    return days + (days === 1 ? ' day' : ' days') + suffix
  }
  interval = absSeconds / 3600
  if (interval > 1) {
    const hours = Math.floor(interval)
    return hours + (hours === 1 ? ' hour' : ' hours') + suffix
  }
  interval = absSeconds / 60
  if (interval > 1) {
    const minutes = Math.floor(interval)
    return minutes + (minutes === 1 ? ' minute' : ' minutes') + suffix
  }
  return Math.floor(absSeconds) + (absSeconds === 1 ? ' second' : ' seconds') + suffix
}

export function expiringInXDays(date, days) {
  if (date) {
    const inXDaysTime = new Date()
    inXDaysTime.setDate(inXDaysTime.getDate() + days)
    if (inXDaysTime > new Date(date) && new Date(date) > new Date()) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
